import { AnalyticsBrowser, Options } from '@segment/analytics-next';

import { createUploadTrackingDelegate } from './tracking.upload';

let uploadTracking: ReturnType<typeof createUploadTrackingDelegate> | undefined;

export function bindUploadSegmentTracking(
  analytics: AnalyticsBrowser,
  getOptions: () => Options,
): void {
  uploadTracking = createUploadTrackingDelegate({ analytics, getOptions });
}

/**
 * Returns the Segment upload-tracking delegate. Requires `bindUploadSegmentTracking`
 * to have run first — wired once at bootstrap via `tracking.bindUploadTracking()`.
 */
export function segmentUploadTracking(): ReturnType<typeof createUploadTrackingDelegate> {
  if (!uploadTracking) {
    throw new Error(
      'Upload segment tracking is not initialized — call tracking.bindUploadTracking() at bootstrap',
    );
  }

  return uploadTracking;
}
